"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueProp = ValueProp;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const value_props_module_scss_1 = __importDefault(require("../value-props.module.scss"));
function ValueProp({ className, icon, heading, headingClassName, headingTag = 'h3', description, descriptionClassName, imageClassName, onClick, href }) {
    const Container = href ? `a` :
        onClick ? `button` : `div`;
    const classes = (0, classnames_1.default)(value_props_module_scss_1.default['valueProp'], className);
    const imageClasses = (0, classnames_1.default)(value_props_module_scss_1.default['valueProp__image'], imageClassName);
    const textContainerClasses = (0, classnames_1.default)(value_props_module_scss_1.default['valueProp__textContainer']);
    const headingClasses = (0, classnames_1.default)(value_props_module_scss_1.default['valueProp__heading'], headingClassName);
    const descriptionClasses = (0, classnames_1.default)(value_props_module_scss_1.default['valueProp__description'], descriptionClassName);
    const actionProps = href
        ? { href, target: '_self' }
        : { onClick };
    const Heading = headingTag;
    const image = react_1.default.cloneElement(icon, combineClasses(icon, imageClasses));
    const refinedDescription = description
        ? typeof description === 'string'
            ? (0, jsx_runtime_1.jsx)("p", { className: descriptionClasses, dangerouslySetInnerHTML: { __html: description } })
            : react_1.default.cloneElement(description, combineClasses(description, descriptionClassName))
        : null;
    return ((0, jsx_runtime_1.jsxs)(Container, { className: classes, ...actionProps, children: [image, (0, jsx_runtime_1.jsxs)("div", { className: textContainerClasses, children: [(0, jsx_runtime_1.jsx)(Heading, { className: headingClasses, children: heading }), refinedDescription] })] }));
}
const combineClasses = (child, newClasses) => {
    return { className: (0, classnames_1.default)(child.props.className, newClasses) };
};
ValueProp.propTypes = {
    /** Icon or SVG component to pass to a value prop */
    icon: prop_types_1.default.node.isRequired,
    /** Heading text to be inside a defined heading tag, it is rendered with dangerouslySetInnerHTML */
    heading: prop_types_1.default.string.isRequired,
    /** Classname applied to all heading (ex `t-heading3`) */
    headingClassName: prop_types_1.default.string,
    /** Heading tag applied to all value prop headingText */
    headingTag: prop_types_1.default.oneOf([
        'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span'
    ]),
    /** Rendered below the heading. If a string, it will be rendered with dangerouslySetInnerHTML into a paragraph tag*/
    description: prop_types_1.default.node,
    /** Classname applied to all descriptions (ex `t-bodySm`) */
    descriptionClassName: prop_types_1.default.string,
    /** Classname applied to all images */
    imageClassName: prop_types_1.default.string
};
//# sourceMappingURL=value-prop.js.map